<template>
  <ld-json :json="jsonld" />
</template>

<script>
import { LdJson } from 'atoms';
import catalogTextListMixin from 'mixins/catalogTextListMixin';

export default {
  name: 'ProductDetailSchemaFi',
  components: {
    LdJson,
  },
  mixins: [catalogTextListMixin],
  props: {
    catalogData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    jsonld() {
      if (
        this.catalogData?.categoryData?.categoryName &&
        this.textListValue(this.catalogData?.TextList, 'ECOMLANG') &&
        this.$fischer.brandName()
      ) {
        const categorySlug = `${this.$fischer.hostUrlBase()}${this.$fischer.pages.products().url}${this.catalogData.categoryData.Slug}`;

        return JSON.stringify({
          '@context': 'https://schema.org/',
          '@type': 'Product',
          name: this.textListValue(this.catalogData.TextList, 'ECOMLANG'),
          url: `${this.$fischer.hostUrlBase()}${this.$fischer.pages.products().url}${this.catalogData.Slug}`,
          productID: this.catalogData.ProductId,
          image: this.catalogData.Media?.[0]?.Url,
          description: this.textListValue(this.catalogData.TextList, 'DOKBSTMARKDESCR'),
          brand: {
            '@type': 'Brand',
            name: this.$fischer.brandName(),
          },
          isVariantOf: {
            '@type': 'ProductGroup',
            '@id': categorySlug,
            name: this.catalogData.categoryData.categoryName,
            url: categorySlug,
            image: this.catalogData.categoryData.categoryMedia,
          },
        });
      }

      return null;
    },
  },
};
</script>
